export default function Label({ children, htmlFor, variant, isRequired = false, customClass }) {
  const variants = {
    light: 'text-white',
    dark: 'text-custom-dark-blue font-bold',
    gray: 'text-gray-500 font-semibold',
  };

  return (
    <label className={`text-md ${variants[variant]} ${customClass}`} htmlFor={htmlFor}>
      {children} {isRequired && <span className="text-red-500">*</span>}
    </label>
  );
}
